export default __webpack_public_path__ + "static/media/ic-feedback-give.327f8cc9.svg";